export default {
  nav: {
    dashboard: '仪表盘',
    myHabits: '我的习惯',
    calendar: '日历',
    stats: '统计'
  },
  common: {
    search: '搜索习惯...',
    addHabit: '+ 添加习惯',
    edit: '编辑',
    delete: '删除',
    save: '保存',
    cancel: '取消',
    saveChanges: '保存更改',
    noDays: '未设置',
    noReminders: '无提醒',
    noHabitsYet: '暂无习惯',
    noHabitsYetAdd: '还没有习惯，去"我的习惯"添加一个吧！',
    noHabitsForToday: '今天没有需要打卡的习惯',
    description: '描述',
    noDescription: '暂无描述',
    createdAt: '创建时间'
  },
  settings: {
    title: '设置',
    welcome: '欢迎',
    stranger: '陌生人',
    clickAvatar: '点击头像更换',
    enterName: '输入你的名字',
    notification: '通知',
    language: '语言',
    theme: '主题',
    feedback: '反馈',
    usernameExceed: '用户名不能超过10个字符'
  },
  language: {
    english: 'ENGLISH',
    chinese: '中文'
  },
  habitForm: {
    addTitle: '添加习惯',
    editTitle: '编辑习惯',
    name: '名称',
    namePlaceholder: '例如：晨练、阅读',
    description: '描述',
    descriptionPlaceholder: '例如：每天早上6点锻炼30分钟',
    daysPerWeek: '每周天数',
    reminders: '提醒时间',
    hour: '时',
    min: '分',
    enterHabitName: '请输入习惯名称',
    selectReminder: '请选择提醒时间',
    selectDay: '请至少选择一天'
  },
  dashboard: {
    todayTab: '仅今日打卡',
    weekTab: '所有打卡（按周）',
    export: '导出',
    exportSuccess: '数据导出成功！',
    todayCheckin: '今日打卡',
    todayFocus: '专注当下，养成好习惯！',
    todayCompleted: '今日已完成',
    status: '状态',
    checked: '已打卡',
    unchecked: '未打卡',
    suggestedTime: '建议时间',
    weekly: '本周',
    days: '天',
    keepGoing: '继续加油！',
    canOnlyCheckToday: '只能打卡今天的习惯',
    tooEarly: '太早了。提醒时间是 {time}，请在 {after} 之后打卡',
    tooLate: '太晚了。提醒时间是 {time}，请在 {before} 之前打卡',
    timeToTrack: '该追踪：{habits}！',
    timeToTrackMultiple: '该追踪 {count} 个习惯：{habits}！'
  },
  calendar: {
    noHabits: '还没有习惯，去"我的习惯"添加一个吧！'
  },
  stats: {
    selectHabit: '选择习惯',
    allHabits: '所有习惯',
    last7Days: '最近7天',
    last30Days: '最近30天',
    last90Days: '最近90天',
    last365Days: '最近365天',
    currentStreak: '当前连续',
    completionRate: '完成率',
    totalCheckins: '总打卡次数',
    completionTrend: '完成趋势',
    habitHeatmap: '习惯热力图',
    completionRatio: '完成比例',
    habitRankings: '习惯排名',
    noHabitsYet: '暂无习惯',
    overallStats: '所有习惯的总体统计'
  },
  feedback: {
    title: '反馈',
    firstTimeTitle: '首次使用',
    firstTimeDesc: '首次提交时，将向管理员邮箱发送激活邮件。请确认激活以启用后续提交。',
    limits: '限制：每天最多3次提交，两次提交间隔60秒',
    placeholder: '请分享您的反馈，我们重视每一条意见！',
    emailLabel: '您的邮箱（可选）',
    emailPlaceholder: '以便我们就您的反馈与您联系',
    send: '发送',
    sending: '发送中...',
    success: '反馈发送成功！感谢您的意见。',
    failed: '发送失败，请稍后重试。',
    enterFeedback: '请输入反馈内容',
    minLength: '反馈内容至少10个字符',
    tooManyUrls: '反馈不能包含超过2个链接',
    waitSeconds: '请等待 {seconds} 秒后再提交',
    dailyLimit: '您已达到每日提交上限（每天 {limit} 次）'
  },
  days: ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
}
